/* eslint-disable @typescript-eslint/naming-convention -- campos em snake_case espelham o contrato da API */
export enum EnumAyaEventType {
  RUN_STARTED = 'run.started',
  RUN_PHASE = 'run.phase',
  RUN_COMPLETED = 'run.completed',
  RUN_FAILED = 'run.failed',
  RUN_INTERRUPTED = 'run.interrupted',
  RUN_CANCELLED = 'run.cancelled',
  MESSAGE_DELTA = 'message.delta',
  MESSAGE_COMPLETED = 'message.completed',
  TOOL_STARTED = 'tool.started',
  TOOL_COMPLETED = 'tool.completed',
  TOOL_FAILED = 'tool.failed',
  TOOL_INTERRUPTED = 'tool.interrupted',
  SUBAGENT_STARTED = 'subagent.started',
  SUBAGENT_RUNNING = 'subagent.running',
  SUBAGENT_COMPLETED = 'subagent.completed',
  SUBAGENT_FAILED = 'subagent.failed',
  SUBAGENT_INTERRUPTED = 'subagent.interrupted',
  SUBAGENT_CANCELLED = 'subagent.cancelled',
  SUBAGENT_SUPERSEDED = 'subagent.superseded',
  ARTIFACT_CREATED = 'artifact.created',
  CONVERSATION_TITLE_UPDATED = 'conversation.title.updated',
  CONVERSATION_STATE_CHANGED = 'conversation.state.changed',
  CONVERSATION_CREATED = 'conversation.created',
  CONVERSATION_DELETED = 'conversation.deleted',
  USER_STREAM_RESET = 'user_stream.reset',
  APPROVAL_REQUIRED = 'approval.required'
}
